var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPptxIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0276 4.9925V13.0214C13.0276 13.7691 12.4215 14.3752 11.6739 14.3752H3.32592C2.57826 14.3752 1.97217 13.7691 1.97217 13.0214V1.97875C1.97232 1.23109 2.57826 0.625 3.32592 0.625H8.91717L13.0276 4.9925Z",
    fill: "#E03303"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0276 4.9925H9.81961C9.32118 4.9925 8.91711 4.58844 8.91711 4.09V0.625L13.0276 4.9925Z",
    fill: "#E9714F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.84331 10.1238V10.9505H3.25549V8.5127H4.22846C4.4144 8.5127 4.58018 8.54707 4.72284 8.61582C4.86643 8.68457 4.97752 8.78145 5.05596 8.90848C5.13534 9.03535 5.17409 9.1791 5.17409 9.33941C5.17409 9.57738 5.08956 9.7677 4.9194 9.90957C4.74846 10.0524 4.51487 10.1238 4.21877 10.1238H3.84331ZM3.84331 9.66988H4.22846C4.34221 9.66988 4.4294 9.64082 4.48846 9.58441C4.54846 9.52707 4.57831 9.44691 4.57831 9.34301C4.57831 9.22926 4.54752 9.13848 4.48659 9.07066C4.42487 9.00191 4.34112 8.96754 4.23456 8.9666H3.84331V9.66988Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07561 10.1238V10.9505H5.48779V8.5127H6.46076C6.6467 8.5127 6.81248 8.54707 6.95514 8.61582C7.09873 8.68457 7.20982 8.78145 7.28826 8.90848C7.36764 9.03535 7.40639 9.1791 7.40639 9.33941C7.40639 9.57738 7.32186 9.7677 7.1517 9.90957C6.98076 10.0524 6.74717 10.1238 6.45107 10.1238H6.07561ZM6.07561 9.66988H6.46076C6.57451 9.66988 6.6617 9.64082 6.72076 9.58441C6.78076 9.52707 6.81061 9.44691 6.81061 9.34301C6.81061 9.22926 6.77982 9.13848 6.71889 9.07066C6.65717 9.00191 6.57342 8.96754 6.46686 8.9666H6.07561V9.66988Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63344 8.9666H8.9011V10.9505H8.31407V8.9666H7.59485V8.5127H9.63329L9.63344 8.9666Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7907 9.3227L11.189 8.5127H11.8605L11.1793 9.72191L11.879 10.9505H11.2004L10.7905 10.1257L10.3799 10.9505H9.70398L10.4019 9.72191L9.72164 8.5127H10.3915L10.7907 9.3227Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptxIcon);
export default __webpack_public_path__ + "static/media/pptx-icon.735ad0c0d6087c0d7d604461bcceb7dc.svg";
export { ForwardRef as ReactComponent };